import { gql } from "apollo-boost"

export const CreateChat = gql`
mutation CreateChat($description: String!, $status: Boolean!, $proposeId: ID!, $toId: ID!){
  createChat(
    description: $description,
    status: $status,
    proposeId: $proposeId,
    toId: $toId,
  ){
    id
    description
    createdAt
    status
    from{
        id
    }
    to{
        id
    }
    propose{
        id
    }
  }
}
`

export const SubscriptionChat = gql`
subscription {
         Chat(filter: {
           mutation_in: [CREATED, UPDATED]
         }){
           mutation
           updatedFields
           node {
             id
             description
             createdAt
             status
             from {
               id
             }
             propose {
               id
             }
           }
         }
       }
`

export const allChats = gql`
query ($id: ID){
  allChats (filter:{
    proposeId: $id
  }){
    id
    description
    createdAt
    status
    from {
      id
      name
    }
    to {
      id
      name
    }
    propose {
      id
      createdAt
    }
  }
}
`